import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  DestroyRef,
  ChangeDetectorRef
} from '@angular/core';
import { PitchCardModalBase } from '../pitchcard-modal-base';
import { PhotoGalleriaComponent } from '../../../photo-galleria/photo-galleria.component';
import { PitchCardModalsWrapperService } from '@App/modules/pitch-card-shared/services';

@Component({
  selector: 'app-pitchcard-photo-gallery-modal',
  standalone: true,

  imports: [PhotoGalleriaComponent],
  templateUrl: './pitchcard-photo-gallery-modal.component.html'
})
export class PitchCardPhotoGalleryModalComponent extends PitchCardModalBase {
  @Input() showPhotoGalleriaDialog: any;
  @Input() photoGalleriaImages: any;
  @Input() activeGalleryIndex: any;
  @Input() isMobile: any;

  private pitchCardModalsWrapperService = inject(PitchCardModalsWrapperService);

  onGalleriaHide() {
    this.pitchCardModalsWrapperService.disablePhotoGalleriaDialog();
  }
}
